import {Component, Input} from '@angular/core';
import {switchMap} from 'rxjs/operators';
import {ModalsService} from "../../services/modals.service";
import {Melody} from "../../model/melody";
import {SubscriberService} from "../../services/subscriber.service";

@Component({
  selector: 'app-gift-melody-modal',
  templateUrl: './gift-melody-modal.component.html',
  styleUrls: ['./gift-melody-modal.component.css']
})
export class GiftMelodyModalComponent {
  @Input() melody: Melody;

  msisdn = '';
  msisdnError: string | null = null;
  requestInProgress = false;
  giftSuccess = false;
  showGiftChoice = false;
  privet = false;
  privetPlus = false;
  privetPlusPurchase = true;

  private readonly ERROR_MESSAGES: Record<string, string> = {
    'MSISDN_FROM_IS_BLOCKED': 'gift-modal.msisdn-blocked',
    'MSISDN_IS_WRONG': 'gift-modal.wrong-operator',
    'MELODY_ALREADY_EXISTS': 'gift-modal.melody-exist',
    'SUBSCRIBER_IS_IN_ACTIVATION': 'gift-modal.request-in-queue'
  };

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService) {
  }

  close(): void {
    this.modalsService.hideModal();
  }

  msisdnChanged(): void {
    if (this.msisdn && !this.msisdn.startsWith('7')) {
      this.msisdn = '7' + this.msisdn.replace(/^7+/, '');
    }
    this.msisdnError = null;
  }

  chooseMelody(): void {
    const isValid = this.msisdn.length === 11 && !this.requestInProgress && this.validateMsisdn();
    if (!isValid) {
      this.requestInProgress = false;
      return;
    }

    this.requestInProgress = true;
    if (this.subscriberService.getCurrentMsisdn() === this.msisdn) {
      this.msisdnError = 'gift-modal.cannot-gift-to-yourself';
      this.requestInProgress = false;
      return;
    }

    this.subscriberService.checkMsisdn(this.msisdn).pipe(
      switchMap((isBeeline: boolean | null) => {
        if (isBeeline === false) {
          this.showGiftChoice = false;
          throw new Error('gift-modal.wrong-operator');
        }
        return this.subscriberService.getStatusesSubscriber(this.msisdn);
      })
    ).subscribe({
      next: (response: any) => {
        const activeServices = response?.subscriberSubscriptions
          ?.filter((sub: any) => sub.status === 'ACTIVE')
          .map((sub: any) => sub.serviceType) || [];

        this.privet = activeServices.includes('PRIVET');
        this.privetPlus = activeServices.includes('PRIVET_PLUS');
        if (this.privet) {
          this.privetPlusPurchase = false;
        }
        this.showGiftChoice = true;
      },
      error: (error) => {
        this.showGiftChoice = false;
        this.msisdnError = this.msisdnError || error.message || 'gift-modal.unexpected-error';
      }
    }).add(() => {
      this.requestInProgress = false;
    });
  }

  giftMelody(): void {
    if (this.requestInProgress) return;

    this.requestInProgress = true;
    this.subscriberService.giftMelody(this.msisdn, this.melody, this.privetPlusPurchase)
      .subscribe({
        next: (result) => {
          const isSuccess = result === 'SUCCESS' || result === 'NO_MONEY';
          this.giftSuccess = isSuccess;

          this.msisdnError = isSuccess ? null : (this.ERROR_MESSAGES[result] || 'gift-modal.unexpected-error');
          this.requestInProgress = false;
        },
        error: (error) => {
          console.error('Gift melody error:', error);
          this.giftSuccess = false;
          this.msisdnError = 'gift-modal.unexpected-error';
          this.requestInProgress = false;
        }
      });
  }

  isMelodyPaid(): boolean {
    return parseFloat(this.melody.priceBuy) > 0;
  }

  private validateMsisdn(): boolean {
    const isValid = !!this.msisdn && this.msisdn.length === 11;
    this.msisdnError = isValid ? null : 'gift-modal.wrong-msisdn';
    return isValid;
  }

  togglePlan(selectPrivetPlus: boolean) {
    this.privetPlusPurchase = selectPrivetPlus;
  }
}
